import React, { useState, useEffect } from 'react';
import Spacer from "../components/Spacer";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InventoryService from '../services/InventoryService';
import DirectionService from "../services/DirectionService";

function FilterValidation(props) {
    const { type, value, onChangeDirection } = props;

    const useStyles = makeStyles((theme) => ({
        paper: {
            padding: theme.spacing(2),
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
            elevation: 0,
        },
        style1: {
            fontSize: "5em",
        },
        labelPosition: {
            fontWeight: 500,
        },
    }));

    const classes = useStyles();

    // État du formulaire
    const [form, setForm] = useState({
        name_materiel: "",
        code_immo: "",
        state: "",
        logistics_manager: "",
        status1: "",
        status2: "",
        mes_materiels: false,
    });

    const [logistics_manager, setLogistics_manager] = useState([]);
    const [dir, setDir] = useState([]);

    // Gestion générique : si le champ modifié est "logistics_manager",
    //    on remonte aussi la valeur au parent via onChangeDirection
    const handleChanges = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        setForm((prev) => ({ ...prev, [name]: newValue }));

        localStorage.setItem(name, newValue);
        localStorage.setItem("changedImputFilterValidation", 1);

        // IMPORTANT : remonter la direction au parent
        if (name === "logistics_manager" && onChangeDirection) {
            onChangeDirection(newValue);
        }
    };

    const SetFilter = (name, value) => {
        if (!value) {
            if (localStorage.getItem(name)) {
                localStorage.setItem(name, localStorage.getItem(name));
            }
        } else {
            localStorage.setItem(name, value);
        }
    };

    useEffect(() => {
        InventoryService.logistics_manager().then((res) => {
            if (res && res.status) {
                setLogistics_manager(res.data);
            }
        });

        DirectionService.getDirection().then((res) => {
            if (res && res.status) {
                setDir(res.data);
            }
        });

        // Initialisation du formulaire depuis le localStorage
        setForm({
            name_materiel: localStorage.getItem('name_materiel') || "",
            code_immo: localStorage.getItem('code_immo') || "",
            state: localStorage.getItem('state') || "",
            logistics_manager: localStorage.getItem('logistics_manager') || "",
            status1: localStorage.getItem('status1') || "",
            status2: localStorage.getItem('status2') || "",
            mes_materiels: localStorage.getItem('mes_materiels') === 'true',
        });

        SetFilter('name_materiel', localStorage.getItem('name_materiel'));
        SetFilter('state', localStorage.getItem('state'));
        SetFilter('logistics_manager', localStorage.getItem('logistics_manager'));
        SetFilter('status1', localStorage.getItem('status1'));
        SetFilter('status2', localStorage.getItem('status2'));
        SetFilter('code_immo', localStorage.getItem('code_immo'));
        SetFilter('mes_materiels', localStorage.getItem('mes_materiels'));
    }, []);

    //  Synchronisation : si le parent reset la valeur (via la prop `value`),
    useEffect(() => {
        if (value !== undefined && value !== null) {
            setForm((prev) => ({ ...prev, logistics_manager: value }));
        }
    }, [value]);

    return (
        <Grid container item xs={12}>
            <Spacer y={4} />
            <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <Spacer y={2} />
                    <label className={classes.labelPosition}>Matériel:</label>
                    <Spacer y={0.2}></Spacer>
                    <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        value={form.name_materiel}
                        name="name_materiel"
                        type="text"
                        onChange={handleChanges}
                        style={{ width: '300px' }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Spacer y={2} />
                    <label className={classes.labelPosition}>Code Immobilisation:</label>
                    <Spacer y={0.2}></Spacer>
                    <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        value={form.code_immo}
                        name="code_immo"
                        type="text"
                        onChange={handleChanges}
                        style={{ width: '300px' }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Spacer y={2} />
                    <label className={classes.labelPosition}>Statut Matériel:</label>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={form.state}
                            name="state"
                            style={{ width: '300px' }}
                            onChange={handleChanges}
                        >
                            <MenuItem value=''>Tous</MenuItem>
                            <MenuItem value='AFFECTE'>Affecté</MenuItem>
                            <MenuItem value='EN_STOCK'>En stock</MenuItem>
                            <MenuItem value='NON_AFFECTE'>Non affecté</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Spacer y={2} />
                    <label className={classes.labelPosition}>Direction:</label>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={form.logistics_manager}
                            label="direction"
                            name="logistics_manager"
                            style={{ width: '300px' }}
                            onChange={handleChanges}
                        >
                            <MenuItem value='0'>Tous</MenuItem>
                            {dir.map((row) => (
                                <MenuItem key={row.direction_id} value={row.direction_id}>
                                    {row.last_name}({row.name})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="mes_materiels"
                                    checked={form.mes_materiels}
                                    onChange={handleChanges}
                                />
                            }
                            label="Mes matériels"
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={4}></Grid>
                <Grid item xs={12} sm={6} md={4}></Grid>

                <Grid item xs={12} sm={6} md={4}></Grid>
                <Grid item xs={12} sm={6} md={4}></Grid>
                <Grid item xs={12} sm={6} md={4}></Grid>
            </Grid>
        </Grid>
    );
}

export default FilterValidation;